<template>
  <div class="grid-view">
    <div class="main-content">
      <div style="width: 100%;margin-top: 5px; min-width: 1280px" class="cargo-advance-search">
        <el-form
          label-position="middle"
          label-width="80px"
        >
          <div class="el-form-item-wrapper" style="display: flex">
            <el-form-item :label="$t('CargoMsg.Cargo_InstructionName')">
              <el-input v-model="filter.instructionName" no="0" :placeholder="$t('SeaExport.PleaseInputAKeyword')" style="width: 300px" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_BusinessType')">
              <cargo-advance-select
                no="1"
                tag-value="code"
                filterable
                clearable
                style="width: 290px"
                :select-type="selectTypeNames.local_cache_SystemConstants$SOP_CONFIG_LOBS"
                @parentCallBack="p=>{filter.lob=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_InstructionType')">
              <cargo-advance-select
                no="2"
                tag-value="code"
                filterable
                clearable
                style="width: 290px"
                :static-options="INSTRUCTION_TYPES"
                @parentCallBack="p=>{filter.instructionType=p.value}"
              />
            </el-form-item>
            <div style="padding-left: 10px">
              <el-button no="3" type="primary" @click="filter.pageNum=1;queryHandler()">
                {{ $t('CargoMsg.Cargo_Query') }}
              </el-button>
              <el-button no="4" type="primary" @click="addHandler">
                {{ $t('CargoMsg.Cargo_Add') }}
              </el-button>
              <el-button no="5" type="primary" @click="editHandler">
                {{ $t('CargoMsg.Cargo_Edit') }}
              </el-button>
              <el-button no="6" type="danger" @click="deleteHandler">
                {{ $t('CargoMsg.Cargo_OrderDelete') }}
              </el-button>
            </div>
          </div>
        </el-form>
      </div>
      <div class="section grid-wrapper" style="flex-grow: 1;">
        <cargo-ag-grid
          no="grid"
          config-module="1014251"
          :column-defs="columnDefs"
          :row-data="rowData"
          :grid-params.sync="girdParams"
          :grid-options="gridOptions"
        />
      </div>
      <div class="app-main-inner-row row-pagination">
        <cargo-pagination
          no="pagination"
          config-module="1014251"
          :total="total"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          @pagination="queryHandler"
        />
      </div>
    </div>
    <!-- 新增编辑弹框 -->
    <el-dialog
      ref="settingDialog"
      v-el-drag-dialog
      :visible.sync="settingDialog.visible"
      :title="settingDialog.title"
      width="640px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="130px" label-position="right">
          <el-form-item :label="$t('CargoMsg.Cargo_InstructionName')">
            <el-input v-model="settingDialog.form.instructionName" no="instructionName" style="width: 390px;" maxlength="20" @blur="() => settingDialog.form.instructionName = settingDialog.form.instructionName.trim()" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_InstructionType')" label-width="130px">
            <cargo-advance-select
              no="instructionType"
              tag-value="code"
              filterable
              clearable
              style="width: 390px"
              :default-value="settingDialog.form.instructionType"
              :static-options="INSTRUCTION_TYPES"
              @parentCallBack="p=>{settingDialog.form.instructionType=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_BusinessType')" label-width="130px">
            <cargo-advance-select
              no="lobs"
              tag-value="code"
              filterable
              clearable
              multiple
              style="width: 390px"
              :default-multiple-value="settingDialog.form.lobs"
              :select-type="selectTypeNames.local_cache_SystemConstants$SOP_CONFIG_LOBS"
              @parentCallBack="p=>{settingDialog.form.lobs=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.ApplicationModule')">
            <el-checkbox v-model="settingDialog.form.isApplyUiCustom" no="isApplyUiCustom">{{ $t('SystemMaintenance.UIFieldConfiguration') }}</el-checkbox>
            <el-checkbox v-model="settingDialog.form.applySopBoard" no="applySopBoard">{{ $t('SystemMaintenance.SOPPanel') }}</el-checkbox>
            <el-checkbox v-model="settingDialog.form.applyAutoExecute" no="applyAutoExecute">{{ $t('SystemMaintenance.AutomatedExecution') }}</el-checkbox>
            <el-checkbox v-model="settingDialog.form.invokeAutomatedExecution" no="invokeAutomatedExecution">{{ $t('SystemMaintenance.InvokeAutomatedExecution') }}</el-checkbox>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_RuleCode')">
            <el-input v-model="settingDialog.form.ruleCode" no="ruleCode" type="textarea" :rows="3" style="width: 390px;" @blur="() => settingDialog.form.ruleCode = settingDialog.form.ruleCode.trim()" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_CodeParameterValues')">
            <el-input v-model="settingDialog.form.codeParamDescription" no="codeParamDescription" type="textarea" :rows="3" style="width: 390px;" @blur="() => settingDialog.form.codeParamDescription = settingDialog.form.codeParamDescription.trim()" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_CreateSource')">
            <el-radio-group v-model="settingDialog.form.isPlatform" no="isPlatform" @change="isPlatformChange">
              <el-radio :label="true">{{ $t('CargoMsg.Cargo_Platform') }}</el-radio>
              <el-radio :label="false">{{ $t('CargoMsg.Cargo_Tenant') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="!settingDialog.form.isPlatform" :label="$t('CargoMsg.TENANT_BUSINESS_NAME')">
            <cargo-advance-select
              no="tenant"
              multiple
              :select-type="selectTypeNames.TENANT"
              :cache="false"
              filterable
              clearable
              style="width: 390px;"
              :custom-label="(item)=>`[${item.id}]${item.name}`"
              :default-multiple-value="settingDialog.form.tenantIds || []"
              @parentCallBack="p => settingDialog.form.tenantIds = p.value"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.descr')">
            <el-input v-model="settingDialog.form.remark" no="remark" type="textarea" :rows="3" style="width: 390px;" maxlength="200" @blur="() => settingDialog.form.remark = settingDialog.form.remark.trim()" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="13" type="primary" @click="saveHandler">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
        <el-button no="14" @click="settingDialog.visible=false">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import ColumnUtils from '@/utils/ColumnUtils'
import {
  EMAIL_PARSING_TYPE, INSTRUCTION_SOURCES,
  INSTRUCTION_TYPES
} from '@/class/cargo/model/parameters/SystemConstants'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { getAllTenant } from '@/api/auth'
import {
  deletePlatformInstruction,
  queryPlatformInstruction,
  savePlatformInstruction
} from '@/api/sysManage/baseConfig/instruction'

export default {
  name: 'PlatformInstruction',
  components: {
    CargoAdvanceSelect
  },
  data() {
    return {
      INSTRUCTION_TYPES, INSTRUCTION_SOURCES,
      total: 0,
      isZh: this.$store.getters.language === 'zh',
      EMAIL_PARSING_TYPE,
      selectTypeNames: TYPE_NAMES,
      loading: false,
      selectedRow: null,
      tenants: [],
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          filter: true
        }
      },
      filter: {
        pageNum: 1,
        pageSize: 50,
        paging: true
      },
      settingDialog: {
        isEdit: false,
        title: this.$t('CargoMsg.Cargo_OperationInstructions'),
        visible: false,
        form: {
          uuid: '',
          version: 0,
          instructionName: '',
          instructionType: '',
          lobs: [],
          ruleCode: '',
          codeParamDescription: '',
          isPlatform: true,
          remark: ''
        }
      },
      rowData: [],
      columnDefs: [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_InstructionName'),
          field: 'instructionName',
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_InstructionType'),
          field: 'instructionType',
          width: 200,
          cellRenderer: params => {
            return ColumnUtils.instructionTypeLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_BusinessType'),
          field: 'lobs',
          width: 200,
          cellRenderer: params => {
            return ColumnUtils.fbaIeJobsLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_RuleCode'),
          field: 'ruleCode',
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_CodeParameterValues'),
          field: 'codeParamDescription',
          width: 200
        }, {
          headerName: this.$t('CargoMsg.TENANT_BUSINESS_NAME'),
          field: 'tenantIds',
          width: 200,
          cellRenderer: params => {
            return ColumnUtils.tenantsLabelFunc(params.value, this.tenants)
          }
        }, {
          headerName: this.$t('SeaExport.descr'),
          field: 'remark',
          width: 200
        }, {
          headerName: this.$t('SeaExport.descr'),
          field: 'remark',
          width: 200
        }, {
          headerName: this.$t('SystemMaintenance.ApplicationModule'),
          field: 'applicationModule',
          width: 200,
          cellRenderer: params => {
            const texts = []
            if (params.data.isApplyUiCustom) {
              texts.push(this.$t('SystemMaintenance.UIFieldConfiguration'))
            }
            if (params.data.applySopBoard) {
              texts.push(this.$t('SystemMaintenance.SOPPanel'))
            }
            if (params.data.applyAutoExecute) {
              texts.push(this.$t('SystemMaintenance.AutomatedExecution'))
            }
            if (params.data.invokeAutomatedExecution) {
              texts.push(this.$t('SystemMaintenance.InvokeAutomatedExecution'))
            }
            return texts.length > 0 ? texts.join(',') : ''
          }
        }
      ]
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    }
  },
  created() {
    getAllTenant().then(res => {
      this.tenants = res.data
    })
  },
  mounted() {
    this.queryHandler()
  },
  methods: {
    queryHandler() {
      this.loading = getLoading4Cxt(this)
      queryPlatformInstruction(this.filter).then(res => {
        if (res.data) {
          if (this.gridApi) {
            this.gridApi.setRowData(res.data.list)
          } else {
            this.rowData = res.data.list
          }
          this.filter.pageNum = res.data.pageNum
          this.filter.pageSize = res.data.pageSize
          this.total = Number(res.data.total)
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    addHandler() {
      this.settingDialog.form = {
        uuid: '',
        version: 0,
        instructionName: '',
        instructionType: '',
        lobs: [],
        ruleCode: '',
        codeParamDescription: '',
        isPlatform: true,
        remark: '',
        isApplyUiCustom: true,
        applySopBoard: true,
        applyAutoExecute: false,
        invokeAutomatedExecution: false
      }
      this.settingDialog.title = this.$t('CargoMsg.Cargo_NewTo') + this.$t('CargoMsg.Cargo_OperationInstructions')
      this.settingDialog.isEdit = false
      this.settingDialog.visible = true
    },
    editHandler() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      if (rows.length !== 1) {
        this.$message.warning(this.$t('common.tips.hasOneOnly'))
        return
      }
      this.settingDialog.form = { ...rows[0] }
      console.log('this.settingDialog.form:', this.settingDialog.form)
      this.settingDialog.title = this.$t('CargoMsg.Cargo_EditTo') + this.$t('CargoMsg.Cargo_OperationInstructions')
      this.settingDialog.isEdit = true
      this.settingDialog.visible = true
    },
    deleteHandler() {
      const selectedRows = this.gridApi.getSelectedRows()
      if (selectedRows.length <= 0) {
        this.$message.error(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.$confirm(this.$t('CargoMsg.Cargo_DeleteConfigTip'), this.$t('Message.WarmReminder'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        this.loading = getLoading4Cxt(this)
        const data = {
          keys: Array.from(selectedRows, p => p.uuid)
        }
        deletePlatformInstruction(data).then(res => {
          this.$message.success(this.$t('CargoMsg.Cargo_DeletedSuccessfully'))
          this.queryHandler()
        }).finally(() => {
          this.loading.close()
        })
      })
    },
    saveHandler() {
      const form = { ...this.settingDialog.form }
      if (!form.instructionName) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PlsInput') + this.$t('CargoMsg.Cargo_InstructionName'))
        return
      }
      if (!form.instructionType) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_InstructionType'))
        return
      }
      if (!form.lobs || form.lobs.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_BusinessType'))
        return
      }
      if (!form.ruleCode) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PlsInput') + this.$t('CargoMsg.Cargo_RuleCode'))
        return
      }
      if (!form.isPlatform && (!form.tenantIds || form.tenantIds.length === 0)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.TENANT_BUSINESS_NAME'))
        return
      }
      const loading = getLoading4Cxt(this.$refs.settingDialog)
      savePlatformInstruction(form).then(() => {
        if (!form.uuid) {
          this.filter.pageNum = 1
        }
        this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
        this.settingDialog.visible = false
        this.queryHandler()
      }).finally(() => {
        loading.close()
      })
    },
    isPlatformChange() {
      if (this.settingDialog.form.isPlatform) {
        this.settingDialog.form.tenantIds = []
      }
    }
  }
}
</script>

<style lang="scss" scoped>

#app /deep/ .el-form-item__label {
  text-align: right;
}

.lable-blue ::v-deep {
  .el-form-item__label {
    color: #1F75D5 !important;
  }
}

</style>
